import { Injectable } from '@angular/core';

import { Http, Response } from '@angular/http';

import { Observable } from 'rxjs/Observable';

import 'rxjs/add/operator/map';

@Injectable()
export class WpService {

  private postsUrl = "/wp-json/";

  constructor(private http: Http) { }

  get(type: string){
    let url = this.postsUrl;
    url = url + 'custom/'
    return this.http
        .get(url + type)
        .map((res: Response) => res.json());

  }

  post(type: string, data){
    let url = this.postsUrl;
    url = url + 'custom/'
    return this.http
        .post(url + type, data)
        .map((res: Response) => res.json());

  }

}



// WEBPACK FOOTER //
// /home/leonhard/Projekte/braungardt/angular/src/app/service/wp.service.ts